<template>
  <div>
    <div class="sm:flex">
      <div class="font-medium mr-6 sm:block hidden">Search In: </div>
      <div
        v-for="entity in searchEntities"
        :key="entity.id"
        class="mr-6 mb-2"
      >
        <label :data-test="entity.id + 'Label'" class="flex cursor-pointer items-center">
          <input
            :checked="entity.enabled"
            type="checkbox"
            class="mr-2"
            style="width: 16px; height: 16px;"
            @input="$emit('input', entity)"
          />
          <span class="flex-1 text-left">{{ entity.label }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    searchEntities: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
